import { memo, useMemo } from 'react';
import { ColumnRowProps } from '../../ColumnRowProps';
import { ColumnGridContainer } from '../ColumnGridContainer';
import { ContractCell } from './ContractCell';
import { useGridRowContext } from '../../../../../../../_grid/contexts/rowContext';

export const ContractColumnRow = memo(function ContractColumnRow({ columnRow, columnIndex }: ColumnRowProps) {
    const containsCategory = useContainsCategory(columnIndex);
    const render = useMemo(() => {
        return columnRow.cells.map((cell, i) => {
            if (!cell) {
                return <div key={i} />;
            }
            return <ContractCell key={cell.id} cell={cell} cells={columnRow.cells} containsCategory={containsCategory} />;
        });
    }, [columnRow.cells, containsCategory]);
    return <ColumnGridContainer>{render}</ColumnGridContainer>;
});

const useContainsCategory = (columnIndex: number) => {
	const { subRows } = useGridRowContext();
	return useMemo(() => {
		return subRows.some(row => row.columnRows[columnIndex].metadata?.ContainsCategoryWork);
	}, [columnIndex, subRows]);
};


